/* ═══════════════════════════════════════════════════════════════
   SERMENT — couture.js
   House animations: pinned hero, full-screen menu, page
   transitions, typographic reveal, Ken Burns, parallax, pulse.
   Vanilla JS — zero dependencies. Loaded after theme.js (defer).
   Everything hangs off the theme's "Animations" setting
   (body[data-animations]) and prefers-reduced-motion.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  document.documentElement.classList.add('js');
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Touch screens: no page veil, no parallax, whole-heading reveal (speed first on phones) */
  var COARSE = window.matchMedia('(pointer: coarse)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    var body = document.body;
    var ANIM = body.dataset.animations === 'true' && !reduced;
    if (!ANIM) body.classList.add('no-anim');

    /* ── Hero context: transparent header + sticky wrapper ── */
    var hero = document.querySelector('.couture-hero');
    var header = document.querySelector('.site-header');
    if (hero) {
      body.classList.add('has-couture-hero');
      var wrap = hero.closest('.shopify-section');
      if (wrap) wrap.classList.add('is-hero-wrap');
    } else {
      body.classList.remove('has-couture-hero');
    }

    /* ── Header: white background on scroll (past the hero if present) ── */
    var headerTick = false;
    var onHeaderScroll = function () {
      if (headerTick) return;
      headerTick = true;
      requestAnimationFrame(function () {
        headerTick = false;
        var limit = hero ? window.innerHeight * 0.55 : 8;
        if (header) header.classList.toggle('scrolled', window.scrollY > limit);
      });
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();

    /* ── 1. Pinned hero: giant logo bound to scroll (rAF) ── */
    if (hero && ANIM) {
      var brand = hero.querySelector('.chh-brand');
      var bottom = hero.querySelector('.chh-bottom');
      var heroTick = false;
      var heroScroll = function () {
        if (heroTick) return;
        heroTick = true;
        requestAnimationFrame(function () {
          heroTick = false;
          var vh = window.innerHeight;
          var p = Math.min(1, Math.max(0, window.scrollY / (vh * 0.72)));
          if (brand) {
            brand.style.opacity = String(1 - p * 1.15);
            brand.style.transform = 'translateY(' + (-p * vh * 0.08) + 'px) scale(' + (1 - p * 0.06) + ')';
          }
          if (bottom) {
            bottom.style.opacity = String(1 - p * 1.6);
            bottom.style.transform = 'translateY(' + (-p * vh * 0.05) + 'px)';
          }
        });
      };
      window.addEventListener('scroll', heroScroll, { passive: true });
      heroScroll();
    }

    /* ── 2. Full-screen menu ── */
    var menu = document.getElementById('coutureMenu');
    var menuBtn = document.getElementById('coutureMenuBtn');
    if (menu && menuBtn) {
      menu.querySelectorAll('.cm-links li').forEach(function (li, i) {
        li.style.setProperty('--i', i);
      });
      var openMenu = function () { body.classList.add('menu-open'); };
      var closeMenu = function () { body.classList.remove('menu-open'); };
      menuBtn.addEventListener('click', openMenu);
      menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
        el.addEventListener('click', closeMenu);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
      /* Navigation from the menu goes through the veil: close after leaving */
      menu.querySelectorAll('.cm-links a, .cm-aside a').forEach(function (a) {
        a.addEventListener('click', function () {
          if (!ANIM) closeMenu();
        });
      });
    }

    /* ── 3. Page transitions: powder veil + arrival reveal ── */
    var veil = document.querySelector('.page-veil');
    if (ANIM) body.classList.add('anim-ready');
    var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
    if (veil && ANIM && !DESIGN_MODE && !COARSE) {
      document.addEventListener('click', function (e) {
        if (e.defaultPrevented) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var a = e.target.closest('a[href]');
        if (!a) return;
        if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
        var url;
        try { url = new URL(a.href, window.location.href); } catch (err) { return; }
        if (url.origin !== window.location.origin) return;
        if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
        e.preventDefault();
        try { var pf = document.createElement('link'); pf.rel = 'prefetch'; pf.href = a.href; document.head.appendChild(pf); } catch (err) {}
body.classList.add('leaving');
        window.setTimeout(function () { window.location.href = a.href; }, 420);
      });
      /* bfcache: remove the veil when navigating back */
      window.addEventListener('pageshow', function (ev) {
        if (ev.persisted) {
          body.classList.remove('leaving');
          body.classList.remove('menu-open');
        }
      });
    }

    /* ── 4. Line-by-line typographic reveal ── */
    var splitLines = function (el) {
      if (el.dataset.rvDone) return;
      el.dataset.rvDone = '1';
      if (!el.textContent.trim()) return;
      /* Words, keeping <em> (italic) and <br> */
      var words = [];
      var walk = function (node, em) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            n.textContent.split(/\s+/).forEach(function (w) { if (w) words.push({ w: w, em: em }); });
          } else if (n.nodeName === 'BR') {
            words.push({ br: true });
          } else if (n.nodeType === 1) {
            walk(n, em || n.nodeName === 'EM' || n.nodeName === 'I');
          }
        });
      };
      walk(el, false);
      el.textContent = '';
      var spans = words.map(function (o) {
        if (o.br) { var b = document.createElement('br'); el.appendChild(b); return { br: true, node: b }; }
        var s = document.createElement(o.em ? 'em' : 'span');
        s.textContent = o.w + ' ';
        s.style.display = 'inline-block';
        s.style.whiteSpace = 'pre';
        el.appendChild(s);
        return { node: s, em: o.em, w: o.w };
      });
      /* Group words by rendered line */
      var lines = [];
      var lastTop = null;
      spans.forEach(function (o) {
        if (o.br) { lastTop = null; return; }
        var top = o.node.offsetTop;
        if (top !== lastTop) { lines.push([]); lastTop = top; }
        lines[lines.length - 1].push(o);
      });
      el.textContent = '';
      lines.forEach(function (ws) {
        var line = document.createElement('span');
        line.className = 'rv-line';
        var inner = document.createElement('span');
        var run = null;
        ws.forEach(function (o) {
          if (o.em) {
            if (!run) { run = document.createElement('em'); inner.appendChild(run); }
            run.appendChild(document.createTextNode(o.w + ' '));
          } else {
            run = null;
            inner.appendChild(document.createTextNode(o.w + ' '));
          }
        });
        line.appendChild(inner);
        el.appendChild(line);
      });
    };
    var rvTargets = document.querySelectorAll('[data-rv]');
    if (ANIM && rvTargets.length && COARSE) {
      /* Phones: no line split (no wait for fonts) — a soft fade of the whole heading, see seo.css */
      rvTargets.forEach(function (el) { el.dataset.rvDone = 'm'; });
      var rvIOm = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('rv-done'); rvIOm.unobserve(en.target); }
        });
      }, { threshold: 0.05 });
      rvTargets.forEach(function (el) { rvIOm.observe(el); });
    } else if (ANIM && rvTargets.length) {
      var rvStart = function () {
        rvTargets.forEach(splitLines);
        var rvIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('rv-done');
              rvIO.unobserve(en.target);
            }
          });
        }, { threshold: 0.2 });
        rvTargets.forEach(function (el) { rvIO.observe(el); });
      };
      if (document.fonts && document.fonts.ready) {
        var rvFired = false;
        var rvGo = function () { if (!rvFired) { rvFired = true; rvStart(); } };
        document.fonts.ready.then(rvGo);
        setTimeout(rvGo, 1200);
      } else { rvStart(); }
    }

    /* ── 5. Slow Ken Burns on editorial images ── */
    var kbEls = document.querySelectorAll('.kb');
    if (ANIM && kbEls.length) {
      var kbIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.classList.toggle('kb-run', en.isIntersecting);
        });
      }, { threshold: 0.1 });
      kbEls.forEach(function (el, i) {
        if (i % 2 === 1) el.classList.add('kb-out');
        kbIO.observe(el);
      });
    }

    /* ── 6. Discreet parallax (max ±6%) ── */
    var plxEls = Array.prototype.slice.call(document.querySelectorAll('[data-plx]'));
    if (ANIM && plxEls.length && !COARSE) {
      var visible = new Set();
      var plxIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) visible.add(en.target);
          else visible.delete(en.target);
        });
      }, { rootMargin: '12% 0px' });
      plxEls.forEach(function (el) { plxIO.observe(el); });
      var plxTick = false;
      var plxRun = function () {
        if (plxTick) return;
        plxTick = true;
        requestAnimationFrame(function () {
          plxTick = false;
          var vh = window.innerHeight;
          visible.forEach(function (el) {
            var r = el.getBoundingClientRect();
            var center = r.top + r.height / 2 - vh / 2;
            var ratio = Math.max(-1, Math.min(1, center / vh));
            var amp = parseFloat(el.dataset.plx || '6');
            el.style.setProperty('--plx', (-ratio * amp) + '%');
          });
        });
      };
      window.addEventListener('scroll', plxRun, { passive: true });
      plxRun();
    }

    /* ── 7. Cart-count pulse on add ── */
    if (window.SermentDrawer && typeof window.SermentDrawer.badge === 'function') {
      var badgeFn = window.SermentDrawer.badge.bind(window.SermentDrawer);
      var lastCount = null;
      window.SermentDrawer.badge = function (cart) {
        badgeFn(cart);
        if (lastCount !== null && cart.item_count > lastCount && ANIM) {
          document.querySelectorAll('.cart-count').forEach(function (b) {
            b.classList.remove('pulse');
            void b.offsetWidth;
            b.classList.add('pulse');
          });
        }
        lastCount = cart.item_count;
      };
    }
  });

  document.addEventListener('shopify:section:load', function () {
    try { document.dispatchEvent(new Event('DOMContentLoaded')); } catch (e) {}
  });
})();

/* ═══════════════════════════════════════════════════════════════
   SERMENT — catalogue: color swatches + wishlist.
   Progressive enhancement: without JS the card stays complete
   (decorative swatches, inert heart). No navigation interception —
   buttons are type="button" + stopPropagation.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var WL_KEY = 'serment_wl';

  function readWL() {
    try {
      var v = JSON.parse(window.localStorage.getItem(WL_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function writeWL(list) {
    try { window.localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintWL(root) {
    var list = readWL();
    (root || document).querySelectorAll('[data-ccard-wl]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-wl', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    /* — Wishlist heart — */
    var wl = e.target.closest('[data-ccard-wl]');
    if (wl) {
      e.preventDefault();
      e.stopPropagation();
      var handle = wl.getAttribute('data-handle');
      if (!handle) return;
      var list = readWL();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      writeWL(list);
      paintWL(document);
      return;
    }

    /* — Color swatch: swaps the card's main image — */
    var sw = e.target.closest('[data-ccard-swatch]');
    if (sw) {
      e.preventDefault();
      e.stopPropagation();
      var card = sw.closest('[data-ccard]');
      if (!card) return;
      card.querySelectorAll('[data-ccard-swatch]').forEach(function (b) {
        b.classList.remove('on');
        b.setAttribute('aria-pressed', 'false');
      });
      sw.classList.add('on');
      sw.setAttribute('aria-pressed', 'true');
      var src = sw.getAttribute('data-img');
      var main = card.querySelector('[data-ccard-main]');
      if (main && !main.dataset.orig) {
        main.dataset.orig = main.src;
        if (main.hasAttribute('srcset')) main.dataset.origset = main.getAttribute('srcset');
      }
      if (src && main) {
        main.src = src;
        if (main.hasAttribute('srcset')) main.removeAttribute('srcset');
      } else if (main && main.dataset.orig) {
        main.src = main.dataset.orig;
        if (main.dataset.origset) main.setAttribute('srcset', main.dataset.origset);
      }
      return;
    }

    /* — Filter panel: closes on outside click — */
    document.querySelectorAll('[data-ctool-filter][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  function paintDots(root) {
    var hexOf = window.SermentColourHex;
    if (typeof hexOf !== 'function') return;
    (root || document).querySelectorAll('[data-ccard-swatch][data-color]').forEach(function (b) {
      if (b.classList.contains('is-dot') || b.querySelector('img')) return;
      var hex = hexOf(b.getAttribute('data-color') || '');
      if (hex) { b.style.setProperty('--dot', hex); b.classList.add('is-dot'); }
    });
  }
  function initCatalogue() { paintWL(document); paintDots(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCatalogue);
  } else {
    initCatalogue();
  }
  /* Colour dots depend on window.SermentColourHex (defined by theme.js at DOMContentLoaded) */
  document.addEventListener('DOMContentLoaded', function () { paintDots(document); });
  window.addEventListener('load', function () { paintDots(document); });
  document.addEventListener('shopify:section:load', initCatalogue);
})();